import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import { FullScreen } from "leaflet.fullscreen";

const MapExpand: React.FC = () => {
  const map = useMap();

  useEffect(() => {
    const newControl = new FullScreen({
      position: "bottomright",
    });

    map.addControl(newControl);
  }, [map]);

  return null;
};

export default MapExpand;
